import { render } from "./OrbitMultiselect.vue?vue&type=template&id=4b09958b"
import script from "./OrbitMultiselect.vue?vue&type=script&lang=js"
export * from "./OrbitMultiselect.vue?vue&type=script&lang=js"

import "./OrbitMultiselect.vue?vue&type=style&index=0&id=4b09958b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__